import { render, staticRenderFns } from "./ShopOrderRatio.vue?vue&type=template&id=71c509bc&scoped=true"
import script from "./ShopOrderRatio.vue?vue&type=script&lang=js"
export * from "./ShopOrderRatio.vue?vue&type=script&lang=js"
import style0 from "./ShopOrderRatio.vue?vue&type=style&index=0&id=71c509bc&prod&scoped=true&lang=css"
import style1 from "./ShopOrderRatio.vue?vue&type=style&index=1&id=71c509bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c509bc",
  null
  
)

export default component.exports